import { gql } from '@apollo/client/core'

export const scaledImageFragment = gql`
  fragment ScaledImageProps on ScaledImage {
    imageScaleType
    imageUrl
  }
`

export const scaledImagesFragment = gql`
  ${scaledImageFragment}
  fragment ScaledImagesProps on ScaledImages {
    PX_150 {
      ...ScaledImageProps
    }
    PX_300 {
      ...ScaledImageProps
    }
    PX_600 {
      ...ScaledImageProps
    }
    PX_1200 {
      ...ScaledImageProps
    }
    PX_2400 {
      ...ScaledImageProps
    }
  }
`
